export default function copyTo(source: any, target: any) {
  if (target && source) {
    Object.keys(target).forEach((key) => {
      if (source[key] !== undefined) {
        if(Array.isArray(source[key])){
          target[key] = [...source[key]];
        }
        else
          target[key] = source[key];
      }
    });
  }
}

// Ersetzt ALLE Target-Keys aus der Quelle – auch mit undefined –, sodass Felder
// geleert und nicht nur gemergt werden. Anders als copyTo bleibt kein Altwert stehen.
// Array-Felder werden bei fehlendem Quellwert auf [] geleert (nicht undefined),
// damit Modell-Invarianten wie Person.clusterTypes erhalten bleiben.
export function replaceWith(source: any, target: any) {
  if (target && source) {
    Object.keys(target).forEach((key) => {
      if (Array.isArray(source[key])) {
        target[key] = [...source[key]];
      }
      else if (source[key] === undefined && Array.isArray(target[key])) {
        target[key] = [];
      }
      else {
        target[key] = source[key];
      }
    });
  }
}
